
const routes = Object.freeze({
    Dashboard: "/",
    Subscription: "/subscription",
    Wallet: "/wallet",
    ActivityLog: "/activity-log",
    UserManagement: "/user-management",
    Request: "/request",
    Settings: "/settings",
    EnterprisePlan: "/enterprise-plan",
    CompanyDetails: "/company-details/:id",
    AdminLogin: "/auth/login",
    AdminForgotPassword: "/auth/forgot-password",
    AdminResetPassword: "/auth/reset-password",
    WeavrCorporate: "/weavr-corporate",
    PaymentTokenConfirmation: "/payment-token-confirmation"
  });
  
  export default routes;
  